<template lang="">
    <div>
        
    </div>
</template>
<script>
export default {
    data(){
        return {
            nama: "AHM Sparepart Dashboard"
        }
    },
    methods:{
        testing(){
            //alert('test')
            let token = this.$route.query.token
            let product_category_id = this.$route.query.product_category_id
            let isRemember = this.$route.query.isRemember;
            
            let formData = {
                token : token,
                product_category_id:product_category_id,
                isRemember
            }
            this.$http.post('/auth/sso/cross-client', formData)
			.then((resp) => {
                this.error = ''
				var user = resp.data.data;
				console.log(user , resp.data)

				this.$http.defaults.headers.common['Authorization'] = "Bearer " + user.token;
				//user.name = this.form.username

				this.$store.dispatch('setUser', user);
                localStorage.setItem('date_expired', user.token_expired);
				this.$router.push({name : 'Highlights'});
				this.loadFilterOptions()
            })
            .catch((error) => {
                console.log(error);
                this.$swal.fire({
					title : "Error!",
					icon : "error",
					type : "error",
					text : error.response.data.message
				})
                this.$router.push({name : 'Login'})
            })
        }
    },
    created(){
        this.testing()
    },
    computed:{
        token(){
            return this.$route.query.token
        }
    }
}
</script>
<style lang="">
    
</style>